class CitizenshipOptions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOptionClick = this.handleOptionClick.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els.option.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.handleOptionClick)
    })

    document.addEventListener('drawer-open', this.handleOpen)
    document.addEventListener('drawer-close', this.handleClose)
  }

  handleOptionClick (event) {
    const type = event.currentTarget.dataset.type

    this.setCartAttribute('packaging_selection', type)

    this.externalEls?.packaging?.elements.forEach((packagingEl) => {
      packagingEl.innerText = type
    })

    let cartLabel = ''
    if (type === 'Re-use') {
      cartLabel = this.dataset.reuseSelection
    } else if (type === 'Recycle') {
      cartLabel = this.dataset.recycleSelection
    } else if (type === 'Compost') {
      cartLabel = this.dataset.compostSelection
    }

    this.externalEls?.label?.elements.forEach((packagingLabelEl) => {
      packagingLabelEl.innerText = cartLabel
    })

    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.dataset.option = type
    })

    this.openCart()
  }

  handleOpen (event) {
    if (event?.detail?.activeDrawerKey !== 'citizenship') return

    const selectedOption = event?.detail?.trigger?.dataset?.option

    if (selectedOption) {
      this.els.option.elements.forEach((optionEl) => {
        if (optionEl.dataset.type === selectedOption) {
          optionEl.setAttribute('aria-pressed', 'true')
          optionEl.textContent = this.dataset.selected
        } else {
          optionEl.setAttribute('aria-pressed', 'false')
          optionEl.textContent = this.dataset.select
        }
      })
    }
  }

  handleClose (event) {
    if (event?.detail?.closedDrawerKey !== 'citizenship') return

    this.getCartAttribute('packaging_selection')
      .then((result) => {
        if (!result) {
          this.setCartAttribute(
            'packaging_selection',
            window.theme.citizenshipDefaultOption,
          )

          this.externalEls?.packaging?.elements.forEach((packagingEl) => {
            packagingEl.innerText = window.theme.citizenshipDefaultOption
          })

          let cartLabel = ''
          if (window.theme.citizenshipDefaultOption === 'Re-use') {
            cartLabel = this.dataset.reuseSelection
          } else if (window.theme.citizenshipDefaultOption === 'Recycle') {
            cartLabel = this.dataset.recycleSelection
          } else if (window.theme.citizenshipDefaultOption === 'Compost') {
            cartLabel = this.dataset.compostSelection
          }

          this.externalEls?.label?.elements.forEach((packagingLabelEl) => {
            packagingLabelEl.innerText = cartLabel
          })

          this.externalEls?.trigger?.elements.forEach((triggerEl) => {
            triggerEl.dataset.option = window.theme.citizenshipDefaultOption
          })
        }
      })
      .catch((error) => {
        console.error('Error:', error)
      })

    window.setTimeout(() => {
      this.openCart()
    }, 300)
  }

  openCart () {
    window.drawers.activeDrawerKey = 'cart'
  }

  setCartAttribute (attributeKey, attributeValue) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }

  getCartAttribute (attributeKey) {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return data.attributes ? data.attributes[attributeKey] : null
      })
      .catch((error) => {
        console.error('Error fetching cart attribute:', error)
        return null
      })
  }
}

if (!customElements.get('citizenship-options')) {
  customElements.define('citizenship-options', CitizenshipOptions)
}
